import { api } from '@/lib/api-client'
import type { NotificationListResponse, StudentNotification } from './notifications-types'

/**
 * Service boundary for the notifications API. Every write goes through the
 * shared API client, which rejects with an `ApiError` when the server refuses
 * one - callers must surface that state honestly instead of faking flag
 * updates. Preview/demo sessions never call these functions:
 * the server holds no notifications for a preview identity, so demo mode is
 * fully local (a truthful empty panel with zero network calls).
 */

export function getNotifications(limit = 10, offset = 0) {
  const query = new URLSearchParams({ limit: String(limit), offset: String(offset) })
  return api.get<NotificationListResponse>(`/notifications/?${query.toString()}`)
}

/** Single mark-read; the server sets BOTH `is_read` and `is_seen` on this endpoint. */
export function markNotificationRead(id: string) {
  return api.put<StudentNotification>(`/notifications/${id}/read/`, {})
}

/** Batch mark-seen; unlike single mark-read, this touches only `is_seen`. */
export function markNotificationsSeen(notificationIds: string[]) {
  return api.post<{ notifications: StudentNotification[]; action: string }>('/notifications/batch_update/', {
    notification_ids: notificationIds,
    action: 'mark_seen',
  })
}

export function markAllNotificationsSeen() {
  return api.post<{ marked_count: number }>('/notifications/mark_all_seen/')
}
